import React, { useState } from "react"
import { Col, Row } from "antd"
import { Link } from "react-router-dom"
import { useWindowDimensions } from "../../helpers/useWindowDimensions"
import CustomMenu from "../../components/CustomMenu"
import { getNriRoutes } from "./routes"
import { useTranslation } from "react-i18next"
import "./style.css"

const NRI = (props) => {
    const { withCatalog = true, withHeader = false } = props
    const [currentItem, setCurrentItem] = useState(0)
    const { width } = useWindowDimensions()
    const { t } = useTranslation(['nri'])
    const tableSize = width < 1020 ? "small" : "middle"
    const handleChange = (value) => {
        setCurrentItem(value)
    }
    const routes = getNriRoutes(t)
    const Element = routes[currentItem].render
    return (<>
        <div className="nsi">
            <Link to="/">
                <div className="nri__link__back">
                    <img alt="" src="/Arrow.svg" />
                    {t("common:back")}
                </div>
            </Link>
            {withHeader && (
                <h2 className="nsi-header">
                    {t('nri:refBooks')}
                </h2>
            )}
            <Row>
                <Col
                    className="nsiMenu"
                    span={5}
                >
                    <CustomMenu selectedKey={currentItem}>
                        {routes.map((item, index) => {
                            return (
                                (!item.catalog || withCatalog) && (
                                    <Link
                                        key={index}
                                        to="#"
                                        onClick={() => handleChange(index)}
                                    >
                                        <li>
                                            <div>
                                                <span>
                                                    {item.text}
                                                </span>
                                            </div>
                                        </li>
                                    </Link>
                                )
                            )
                        })}
                    </CustomMenu>
                </Col>
                <Col
                    className="nsiContent"
                    span={19}
                >
                    <Element tableSize={tableSize} />
                </Col>
            </Row>
        </div>
    </>
    )
}

export default NRI
